import { useEffect, useMemo, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { getBirthdayDetail, sendBirthdayWish } from '../api/birthdaysApi'

export function useBirthdaysEntryScreen() {
  const navigate = useNavigate()
  const location = useLocation()
  const routeParams = useParams()

  const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search])
  const studentId = routeParams.id || queryParams.get('id')

  const [student, setStudent] = useState(null)
  const [isLoading, setIsLoading] = useState(Boolean(studentId))
  const [isSending, setIsSending] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')
  const [wishMessage, setWishMessage] = useState('')
  const [channel, setChannel] = useState('both')

  useEffect(() => {
    const loadBirthday = async () => {
      if (!studentId) {
        setIsLoading(false)
        return
      }

      setIsLoading(true)
      try {
        const data = await getBirthdayDetail(studentId)
        setStudent(data)
        if (data?.firstName) {
          setWishMessage(
            `Wishing you a very Happy Birthday, ${data.firstName}! May this year bring you great joy, academic excellence, and abundant success.`
          )
        }
      } catch {
        setError('Unable to load student birthday details.')
      } finally {
        setIsLoading(false)
      }
    }

    loadBirthday()
  }, [studentId])

  const handleSendWish = async () => {
    if (!wishMessage.trim()) {
      setError('Please enter a birthday message.')
      return
    }

    setIsSending(true)
    setError('')

    try {
      const result = await sendBirthdayWish(studentId, {
        message: wishMessage.trim(),
        channel,
      })
      setSuccess(result.message || 'Birthday wish sent successfully!')
      setTimeout(() => {
        navigate('/admission/birthdays/list')
      }, 1200)
    } catch {
      setError('Failed to send birthday wish. Please try again.')
    } finally {
      setIsSending(false)
    }
  }

  return {
    state: {
      student,
      isLoading,
      isSending,
      error,
      success,
      wishMessage,
      channel,
      studentId,
    },
    actions: {
      setWishMessage,
      setChannel,
      handleSendWish,
    },
  }
}
